import { ref } from 'vue';

let toastId = 0;
const toasts = ref([]);

export function useToast() {
    const add = (message, duration = 3000) => {
        const id = String(toastId++);

        toasts.value.push({
            id,
            message,
            duration,
        });

        return id;
    };

  const remove = (id) => {
      toasts.value = toasts.value.filter((toast) => toast.id !== id);
  };

  const dismiss = (id) => {
      remove(id);
  };

  return {
      toasts,
      add,
      remove,
      dismiss,
  };
}
